import React from 'react'

const PaperValidated = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='122'
    height='126'
    viewBox='0 0 122 126'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M40.7508 90H81.2446V80H40.7508V90ZM40.7508 70H81.2446V60H40.7508V70ZM30.6274 110C27.8434 110 25.4602 109.021 23.4777 107.062C21.4952 105.104 20.5039 102.75 20.5039 100V20C20.5039 17.25 21.4952 14.8958 23.4777 12.9375C25.4602 10.9792 27.8434 10 30.6274 10H71.1212L101.492 40V100C101.492 102.75 100.5 105.104 98.5178 107.062C96.5353 109.021 94.1521 110 91.3681 110H30.6274ZM66.0595 45V20H30.6274V100H91.3681V45H66.0595Z'
      fill='currentColor'
    />
    <rect x='74' y='90' width='36' height='36' rx='18' fill='white' />
    <path
      d='M89.8961 114.9L100.471 104.325L98.3711 102.225L89.8961 110.7L85.6211 106.425L83.5211 108.525L89.8961 114.9ZM91.9961 123C89.9211 123 87.9711 122.606 86.1461 121.818C84.3211 121.031 82.7336 119.962 81.3836 118.612C80.0336 117.262 78.9648 115.675 78.1773 113.85C77.3898 112.025 76.9961 110.075 76.9961 108C76.9961 105.925 77.3898 103.975 78.1773 102.15C78.9648 100.325 80.0336 98.737 81.3836 97.387C82.7336 96.037 84.3211 94.9683 86.1461 94.1808C87.9711 93.3933 89.9211 92.9995 91.9961 92.9995C94.0711 92.9995 96.0211 93.3933 97.8461 94.1808C99.6711 94.9683 101.259 96.037 102.609 97.387C103.959 98.737 105.027 100.325 105.815 102.15C106.602 103.975 106.996 105.925 106.996 108C106.996 110.075 106.602 112.025 105.815 113.85C105.027 115.675 103.959 117.262 102.609 118.612C101.259 119.962 99.6711 121.031 97.8461 121.818C96.0211 122.606 94.0711 123 91.9961 123Z'
      fill='currentColor'
    />
  </svg>
)

export default PaperValidated
